var _defs, _path, _path2, _path3, _g, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFlutter = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 166 202",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangleGradient"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#000000",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "#616161",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rectangleGradient",
    x1: "0%",
    x2: "0%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#000000",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "#616161",
    stopOpacity: 0.01
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#42A5F5",
    fillOpacity: 0.8,
    d: "M37.7 128.9 9.8 101 100.4 10.4 156.2 10.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A5F5",
    fillOpacity: 0.8,
    d: "M156.2 94 100.4 94 79.5 114.9 107.4 142.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D47A1",
    d: "M79.5 170.7 100.4 191.6 156.2 191.6 156.2 191.6 107.4 142.8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.7071, -0.7071, 0.7071, 0.7071, -77.667, 98.057)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.4,
    height: 39.4,
    x: 59.8,
    y: 123.1,
    fill: "#42A5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.4,
    height: 5.5,
    x: 59.8,
    y: 162.5,
    fill: "url(#rectangleGradient)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 170.7 120.9 156.4 107.4 142.8",
    fill: "url(#triangleGradient)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFlutter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/flutter.4e9eb2f0.svg";
export { ForwardRef as ReactComponent };